import React from 'react'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import cx from 'classnames'
import Fade from '@mui/material/Fade'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import { useSelector } from 'react-redux'
import { selectSmartSearchEnabled } from 'redux/selectors/selectSmartSearchEnabled'

const legacySearchTips = [
  'Use quotation marks to search for exact words or phrases eg, "share buyback"',
  'Use quotation marks around all required search words and phrases to return results with all those exact words and phrases eg, "defective" "share buyback"',
  'Synonyms and acronyms are applied to search terms unless quotation marks are used',
  'Search will not correct typographical errors'
]

const smartSearhTips = [
  <span key={0}>
    <span className='b'>Please enter your search term as a complete sentence or a question</span>
    <br />Rather than keywords (e.g. “What is the required notice period for a general meeting?” rather than “general meeting notice”)
  </span>,
  <span key={1}>
    <span className='b'>Ask your question in natural language</span>
    <br />The way you’d ask a colleague
  </span>,
  <span key={2} className='b'>Please be sure to use the correct spelling</span>,
  <span key={3}>
    <span className='b'>Please ask one question at a time</span>
    <br />For better results enter focused queries rather than multi-step, complex questions
  </span>,
  <span key={4}>
    <span className='b'>Case searches</span>
    <br />When looking for a specific case, please use the checkbox shown below on the results page for better results
  </span>
]

const SearchHelper = ({ searchHelperVisible, setSearchHelperVisible }) => (
  <Fade in={searchHelperVisible} timeout={600}>
    <div
      data-testid='search-tips-panel'
      className='absolute -bottom5 pt6 left-50 x--50-y-100 shadow-8-04 w16-l w-100 bg-white z10 flex flex-column'
      style={{ maxHeight: 'calc(100vh - 6rem)' }}
    >
      <div className='ph6 shrink-0'>
        <CloseIconButton {...{ setSearchHelperVisible }} />
        <h2 className='db tc mh0 mt0 ph0 pt0 pb5 bb-medium b--cadet-blue f4 lh-solid'>
          Search Tips
        </h2>
      </div>
      {/* minHeight: 0 lets this shrink below its content size inside the flex column, which is what lets o-auto actually kick in and scroll instead of just overflowing the panel */}
      <div data-testid='search-tips-list' className='ph6 pb6 o-auto' style={{ minHeight: 0 }}>
        <SearchTips />
      </div>
    </div>
  </Fade>
)

const CloseIconButton = ({ setSearchHelperVisible }) => (
  <IconButton
    classes={{ root: 'absolute right3 top3' }}
    size='small'
    onClick={() => setSearchHelperVisible(false)}
  >
    <CloseIcon />
  </IconButton>
)

const SearchTips = () => {
  const smartSearchEnabled = useSelector(selectSmartSearchEnabled)
  const searchTips = smartSearchEnabled ? smartSearhTips : legacySearchTips

  return (
    <ul className='flex flex-wrap ma0 pa0'>
      {searchTips.map((searchTip, index) => (
        <li
          key={index}
          className={cx(
            'w-100 w-50-l mb4 flex',
            { 'pr5-l': index % 2 === 0 },
            { 'pl5-l': index % 2 === 1 }
          )}
        >
          <ArrowRightIcon />
          <span className='lh-title'>{searchTip}</span>
        </li>
      ))}
    </ul>
  )
}

export default SearchHelper
